<template>
  <button @click="$emit('click')" :class="['btn',red?'btnRed':null,white?'btnWhite':null,round?'boderRadisus':null]">
    {{name}}
  </button>
        

    
 
</template>
<script>
// 导入组件
// import { menu } from '@/api/userMG'

export default {
  name: 'btn',
  // 注册组件
  components: {
    
  },
  props:{
    name:String,
    red:Boolean,
    white:Boolean,
    round:Boolean
  },
  data() {
    return {
   
    }
  },
  
  methods: {
        
  },
  created() {


  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    
  }
}
</script>
<style scoped lang="less">
.boderRadisus
{
  border-radius: 0.4rem;
}
.btn
{
    
    font-size: 1.2rem;
    font-weight: 400;
    padding: 0.7rem 2.4rem;
    outline: none;
    cursor: pointer;
}
.btnRed
{
    background: #EA0E1E;
    color: #fff;
    border: 1px solid #EA0E1E;
}
.btnWhite
{
    background: #fff;
    border: 1px solid #EA0E1E;
    color: #EA0E1E;
    border: 1px solid #EA0E1E;
}
</style>



// WEBPACK FOOTER //
// src/components/btn.vue